import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames/bind';
import { meeting, rtc, user } from '@/models';
import { CodeEditor } from '@/components';
import Whiteboard from '@/components/Whiteboard';
import ViewBox, { viewBoxType } from '../../../ViewBox';
import styles from './index.less';

const $c = classnames.bind(styles);

const H5MainStream = observer(() => {
  if (meeting?.whiteboardUid && meeting.whiteboardAuth) {
    return (
      <div className={$c('h5-main-stream')}>
        <Whiteboard
          channelId={rtc!.cid}
          appkey={meeting.whiteboardAuth.appkey}
          nonce={meeting.whiteboardAuth.nonce}
          curTime={meeting.whiteboardAuth.curTime}
          checksum={meeting.whiteboardAuth.checksum}
          whiteboardUid={meeting.whiteboardUid}
          uid={user!.mid}
          yxuid={user!.yxuid}
          uname={user!.name}
          willClose={meeting!.whiteboardWillClose}
          className={$c('view')}
          whiteboardChannelId={meeting.whiteboardChannelId}
        />
      </div>
    );
  }
  if (meeting?.codeEditorEnabled) {
    return (
      <div className={$c('h5-main-stream')}>
        <CodeEditor />
      </div>
    );
  }
  if (meeting?.screenUid) {
    return (
      <div className={$c('h5-main-stream')}>
        <ViewBox
          yxuid={String(meeting?.screenUserInfo?.yxUid)}
          type={viewBoxType.screen}
          className={$c('no-border', 'view')}
        />
      </div>
    );
  }

  return null;
});

export default H5MainStream;
